import { createFileRoute } from "@tanstack/react-router";
import { SiteShell, PageHero } from "@/components/site/SiteShell";
import { Section, SectionHeader, CTABand } from "@/components/site/Blocks";
import { buildHead } from "@/lib/seo-head";

export const Route = createFileRoute("/es/requisitos-prestamo-dscr")({
  head: () =>
    buildHead({
      title: "Requisitos del Préstamo DSCR | Simply Approved",
      description:
        "Requisitos típicos de préstamos DSCR: crédito, reservas, LTV, DSCR, tipo de propiedad, entidad y experiencia. El prestamista mayorista determina los términos finales.",
      url: "/es/requisitos-prestamo-dscr",
      locale: "es",
      keywords: "requisitos préstamo DSCR, crédito DSCR, reservas DSCR, LTV DSCR, LLC préstamo DSCR",
      breadcrumbs: [
        { name: "Inicio", url: "/es" },
        { name: "Requisitos DSCR", url: "/es/requisitos-prestamo-dscr" },
      ],
      service: { name: "Requisitos de préstamos DSCR" },
    }),
  component: RequirementsPage,
});

function RequirementsPage() {
  return (
    <SiteShell>
      <PageHero eyebrow="Requisitos" title="Lo que generalmente se necesita para un préstamo DSCR." subtitle="Los requisitos exactos varían por prestamista mayorista y escenario. A continuación, los más comunes." />
      <Section>
        <SectionHeader title="Requisitos comunes" />
        <div className="prose prose-slate mt-6 max-w-none">
          <ul>
            <li><strong>Puntaje de crédito:</strong> típicamente 620+; mejores tasas con 680 o más.</li>
            <li><strong>Reservas:</strong> generalmente 6–12 meses de PITIA, dependiendo del programa y DSCR.</li>
            <li><strong>LTV:</strong> hasta 80% en programas elegibles; programas STR y excepciones pueden ser más conservadores.</li>
            <li><strong>DSCR:</strong> generalmente ≥1.0; programas No-Ratio o DSCR bajo requieren compensación.</li>
            <li><strong>Tipo de propiedad:</strong> 1–8 unidades, condominios aprobados, townhomes. STR y multifamiliar tienen sus propios límites.</li>
            <li><strong>Vestimenta:</strong> LLC, LP, S-Corp, C-Corp aceptadas con documentación de entidad.</li>
            <li><strong>Seguros:</strong> seguro de propiedad y responsabilidad vigente; huracán/inundación si aplica.</li>
            <li><strong>Experiencia:</strong> algunos programas exigen historial de arrendador para LTV más alta o propiedades de 5–8 unidades.</li>
          </ul>
          <p>
            No ofrecemos aprobaciones garantizadas ni tasas fijas sin suscripción. Cada escenario se
            envía a uno o más prestamistas mayoristas y la aprobación es cosa del prestamista,
            no de Simply Approved Mortgages LLC.
          </p>
        </div>
      </Section>
      <CTABand title="¿Cumple los requisitos?" body="Envíe su escenario para una revisión sin compromiso." />
    </SiteShell>
  );
}
